module.exports = __webpack_public_path__ + "img/Deathknight-orc-f-70.1f6c816c.gif";